WiseMetering.Views.ShowDatelkaIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/datelka/show',
    title: () => i18next.t('modal.title.integrations.show'),

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            configurationName: this.model.configuration().get('name'),
            indicator: this.model.indicator(),
            integrationIndicators: this.model.integrationIndicators()
        };
    }
});
